import { render, staticRenderFns } from "./contractFile.vue?vue&type=template&id=1b024b70&scoped=true&"
import script from "./contractFile.vue?vue&type=script&lang=js&"
export * from "./contractFile.vue?vue&type=script&lang=js&"
import style0 from "./contractFile.vue?vue&type=style&index=0&id=1b024b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b024b70",
  null
  
)

export default component.exports